import { render } from "./DialogActions.vue?vue&type=template&id=7e5c4034&scoped=true&ts=true"
import script from "./DialogActions.vue?vue&type=script&lang=ts"
export * from "./DialogActions.vue?vue&type=script&lang=ts"

import "./DialogActions.vue?vue&type=style&index=0&id=7e5c4034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5c4034"]])

export default __exports__